import { StringHelpers } from 'helpers/string-helpers';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DateHelpers = {
  getCurrentYear: () => {
    const date = new Date();
    return date.getFullYear();
  },

  getCurrentDate: () => {
    const date = new Date();
    const day = date.getDate();
    return `${DateHelpers.getMonthShortNameByIndex(date.getMonth())} ${
      day > 9 ? day : `0${day}`
    }, ${date.getFullYear()}`;
  },

  getMonthShortNameByIndex: monthIndex => {
    const date = new Date(1970, monthIndex, 1);
    return date.toLocaleString('en-us', { month: 'short' });
  },

  getMonthNameByIndex: monthIndex => monthNames[monthIndex],

  // example: 2019-05-17 12:46:21 ->  May 17, 2019
  getMonthNameDayYearFormat: string => {
    const regex = new RegExp('\\d{4}-\\d{2}-\\d{2}(\\s.*)?');
    if (!string.match(regex)) {
      return string;
    }
    const arr = string.split(' ')[0].split('-');
    const date = new Date(arr[0], arr[1] - 1, arr[2]);
    const month = date.toLocaleString('en-us', { month: 'short' });
    return `${month} ${arr[2]}, ${arr[0]}`;
  },

  getDiffInMonth: ({ StartMonth, StartYear }, { EndMonth, EndYear }) => {
    const eMs = Number(EndMonth) + 12 * Number(EndYear);
    const sMs = Number(StartMonth) + 12 * Number(StartYear);

    let diffInYears = Math.round((eMs - sMs) / 12);
    let diffInMonth = eMs - sMs - 12 * diffInYears;

    if (diffInMonth < 0) {
      diffInYears = diffInYears - 1;
      diffInMonth = diffInMonth + 12;
    }

    const yrs = `${
      diffInYears ? `${diffInYears} ${diffInYears > 1 ? `yrs` : `yr`}` : ``
    }`;
    const mos = `${
      diffInMonth ? `${diffInMonth} ${diffInMonth > 1 ? `mos` : `mo`}` : ``
    }`;

    return diffInYears < 0 ? '' : `${yrs}${yrs && mos ? ` ` : ``}${mos}`;
  },

  getDateArray: date => {
    return date.split(' ')[0].split('-');
  },

  // example result: '2019-09-31 14:21'
  jsDateToString: (date, withTime = true) => {
    return (
      date.getFullYear() +
      '-' +
      StringHelpers.appendLeadingZeroes(date.getMonth() + 1) +
      '-' +
      StringHelpers.appendLeadingZeroes(date.getDate()) +
      ' ' +
      (withTime
        ? StringHelpers.appendLeadingZeroes(date.getHours()) +
          ':' +
          StringHelpers.appendLeadingZeroes(date.getMinutes())
        : '')
    );
  },
};

export const TimeHelpers = {
  secondsToTime: (s, inObject = false) => {
    if (typeof s !== 'number') {
      s = Number(s);
    }
    const hours = '' + Math.floor(s / 3600);
    const minutes = '' + Math.floor((s % 3600) / 60);
    const seconds = '' + Math.ceil((s % 3600) % 60);

    const obj = {
      h: hours.length === 1 ? '0' + hours : hours,
      m: minutes.length === 1 ? '0' + minutes : minutes,
      s: seconds.length === 1 ? '0' + seconds : seconds,
    };

    return inObject ? obj : Object.values(obj).join(':');
  },

  secondsToTimeInAmPm: (s, inObject = false, withSeconds = false) => {
    const time = TimeHelpers.secondsToTime(s, true);

    time['ampm'] = time['h'] >= 12 && time['h'] < 24 ? 'pm' : 'am';
    time['h'] = '' + (time['h'] % 12 ? time['h'] % 12 : 12);
    time['h'] = time['h'].length === 1 ? '0' + time['h'] : time['h'];

    return inObject
      ? time
      : time['h'] +
          ':' +
          time['m'] +
          (withSeconds ? +':' + time['s'] : '') +
          ' ' +
          time['ampm'];
  },

  timeToSeconds: t => {
    const buffer = t.split(':');
    if (buffer.length !== 3) {
      return null;
    }

    const data = buffer.map(val => Number(val));
    return data[0] * 3600 + data[1] * 60 + data[2];
  },

  timeToAmPm: (time, inObject = false, withSeconds = false) => {
    const [h = 0, m = 0, s = 0] = time.split(':');
    const data = { h, m, s };
    data.h = '' + (h % 12 ? h % 12 : 12);
    data.h = data.h.length === 1 ? '0' + data.h : data.h;
    data.m = m;
    if (withSeconds) {
      data.s = s;
    }
    data.ampm = h >= 12 && h < 24 ? 'pm' : 'am';

    return inObject
      ? data
      : withSeconds
      ? `${data.h}:${data.m}:${data.s} ${data.ampm}`
      : `${data.h}:${data.m} ${data.ampm}`;
  },
};

export default { DateHelpers, TimeHelpers };
